import React from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';

import { useFirebase } from '../../contexts/Firebase';
import { set } from '../../helpers/Firebase/base';
import { getEncryptedMatches } from '../../helpers/people';

const ActionDialog = ({ open, setOpen, onFinish }) => {
  const firebase = useFirebase();

  const confirm = () => {
    const matches = getEncryptedMatches();
    const matchesRef = firebase.matches();

    set(matchesRef, matches)
      .then(() => onFinish('Success'))
      .catch(() => onFinish('Error'));
  };

  return (
    <Dialog open={open}>
      <DialogTitle>
        Confirm Matching Action
      </DialogTitle>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button onClick={confirm} variant={'contained'}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionDialog;